import {Injectable} from '@angular/core';
import {EvkHttpService, EvkRequestType, MessageCrudService} from '@evomatik/evk-common';
import {Observable} from 'rxjs';
import {EvkSecurityControlDataService} from '@evomatik/evk-seguridad';
import {MatDialog} from '@angular/material/dialog';
import {
    MotivoCancelacionCreateComponent
} from '../diligencia-motivo-cancelacion/motivo-cancelacion/motivo-cancelacion-create.component';
import {CancelarDiligenciaService} from '../diligencia-motivo-cancelacion/services/cancelar-diligencia.service';
import {DiligenciaTareaModel} from "../../../../../../diligencia/models/diligencia-tarea.model";
import {TareaDocumentoModel} from "../../../../../../diligencia/models/tarea-documento.model";
import {MotivoEstadoComponent} from "../motivo-estado/motivo-estado.component";
import {EvkDiligenciaEnviarService} from "./evk-diligencia-enviar.service";

@Injectable()
export class DiligenciasSharedActionsService {

    constructor(
        private messageCrudService: MessageCrudService,
        private evkDiligenciaEnviarService: EvkDiligenciaEnviarService,
        private evkSecurity: EvkSecurityControlDataService,
        private http: EvkHttpService,
        private dialog: MatDialog,
        private cancelarService: CancelarDiligenciaService,
    ) {
    }

    enviarDiligencia(diligencia: DiligenciaTareaModel): Observable<DiligenciaTareaModel> {
        return new Observable<DiligenciaTareaModel>(observer => {
            const confirmDialog = this.messageCrudService.openConfirmDialog({
                warn: '¿Está seguro de enviar esta actuación?',
                goonbtn: 'Aceptar'
            });
            confirmDialog.componentInstance.resolveEvent.subscribe(() => {
                this.evkDiligenciaEnviarService.edit(diligencia).subscribe((response) => {
                    this.messageCrudService.snackbarMessage('Actuación enviada de forma exitosa.');
                    confirmDialog.close();
                    observer.next(response.data);
                }, error => {
                    this.messageCrudService.snackbarSimpleError('No se ha podido enviar la actuación :' + error);
                    confirmDialog.close();
                    observer.error();
                });
            });
        });
    }

    crearCopiaTarea(tarea: TareaDocumentoModel): Observable<DiligenciaTareaModel> {
        return new Observable<DiligenciaTareaModel>(observer => {
            const unidadData = this.evkSecurity.getUsuarioInfo().orgLogica;
            if (tarea.tipoTarea === 'EXTERNA') {
                tarea.tipoTarea = 'SIMPLE';
            }
            const copia = {
                id: tarea.idNegocio,
                nombreCompletoCreacion: this.evkSecurity.getUsuarioInfo().nombreCompleto,
                unidadOrigen: unidadData,
                idDiligenciaConfig: tarea.detalle.idDiligenciaConfig,
                clasificacion: tarea['diligencia'].clasificacion
            };

            this.http.post<EvkRequestType<DiligenciaTareaModel>>(`/seaged-diligencias-service/diligencia/clonar`, {
                data: copia,
                id: 'NA'
            }).subscribe((res) => {
                this.messageCrudService.snackbarMessage('La actuación se clonó exitosamente');
                observer.next(res.data);
            }, error => {
                this.messageCrudService.snackbarMessage('No se ha podido clonar la actuación: ' + error);
                observer.error();
            });
        });
    }

    /*addPostFijo(data: TareaDocumentoModel) {
        return new Observable<boolean>(observer => {
            const dialog = this.dialog.open(PostFijoCreateComponent, {
                panelClass: 'post-fijo-dialog',
                width: '900px',
                data: {data},
            });

            dialog.afterClosed().subscribe((response) => {
                if (response) {
                    observer.next(true);
                }
            });
        });
    }*/

    verRechazo(tarea: TareaDocumentoModel) {
        const observaciones = this.checkMotivoRechazo(tarea.estadoTarea);
        this.dialog.open(MotivoEstadoComponent, {
            panelClass: 'rechazar-component-dialog',
            width: '900px',
            data: {
                titulo: 'Motivo de rechazo',
                observaciones: observaciones
            }
        });
    }

    checkMotivoRechazo(estatusList) {
        let observaciones = '';
        estatusList.forEach((estatus) => {
            if (estatus.activo) {
                observaciones = estatus.observaciones;
            }
        });
        return observaciones;
    }

    ingresarMotivoCancelacion(diligenciaModel: DiligenciaTareaModel) {
        return new Observable<any>(observer => {
            const dialog = this.dialog.open(MotivoCancelacionCreateComponent, {
                panelClass: 'motivo-cancelacion-dialog',
                width: '900px',
                data: {},
            });
            dialog.afterClosed().subscribe((response) => {
                if (response) {
                    console.log(response);
                    const diligencia = diligenciaModel;
                    diligencia['motivoEstado'] = response.motivo;
                    this.cancelarService.edit(diligencia).subscribe(
                        (response) => {
                            this.messageCrudService.snackbarMessage('La actuación fue cancelada con éxito');
                            observer.next(response);
                        },
                        (error) => {
                            this.messageCrudService.snackbarError(error);
                            observer.next(response);
                        }
                    );
                } else {
                    observer.next(true);
                }
            });
        });
    }

    verMotivoCancelacion(tarea: TareaDocumentoModel) {
        const observaciones = this.checkMotivoRechazo(tarea.estadoTarea);
        this.dialog.open(MotivoEstadoComponent, {
            panelClass: 'rechazar-component-dialog',
            width: '900px',
            data: {
                titulo: 'Motivo de cancelación',
                observaciones: observaciones
            }
        });
    }
}
